import React, { useEffect, useState } from 'react';
import { SafeAreaView, StatusBar, View, Image, ImageBackground, ScrollView } from 'react-native';
import { Searchbar, Text, useTheme } from 'react-native-paper';
import { NavigationWithProps } from '../../core/Types';
import { RootNavParamList } from '../../../App';
import { useTherapists } from '../../core/api/therapists';
import { PublicAgenda, TherapistModel } from '../../core/models/TherapistModel';
import { Background, Pet } from '../../assets/images';
import { CardListLoader } from '../../components/Loaders';
import TherapistCard from '../../components/TherapistCard';
import { PaginatedResponse } from '../../core/models/ApiResponse';

let timeout: NodeJS.Timeout | undefined = undefined;

const SelectTherapist: React.FC<NavigationWithProps<{}, RootNavParamList, "SelectTherapist">> = ({ navigation }) => {

    const theme = useTheme();
    const therapists = useTherapists();

    const [therapistList, setTherapistList] = useState<PaginatedResponse<PublicAgenda> | undefined>(undefined);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');

    const fetchTherapists = (searchText?: string, submit: boolean = false) => {
        setSearchText(searchText || "");

        const search = searchText?.trim() ?? "";
        if (search.length === 0) {
            return;
        }

        const searchFn = async () => {
            setLoading(true);
            setSubmitted(false);

            const data = await therapists.listTherapists(search, 1, 50);

            setTherapistList(data);
            setSubmitted(true);
            setLoading(false);
        };

        if (submit) {
            searchFn().catch((error) => {
                console.error("Error fetching therapists:", error);
                setLoading(false);
            });
            timeout = undefined;
            return;
        }

        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
            return;
        }

        timeout = setTimeout(() => {
            searchFn().catch((error) => {
                console.error("Error fetching therapists:", error);
                setLoading(false);
            });
        }, 500);
    };

    const openTherapistProfile = (therapist: PublicAgenda) => {
        navigation.navigate("Therapist", therapist);
    };

    return (
        <SafeAreaView style={{
            flex: 1,
            backgroundColor: theme.colors.surface,
            position: "relative",
        }}>
            <StatusBar
                translucent
                barStyle={theme.dark ? "light-content" : "dark-content"}
                backgroundColor="transparent"
            />
            <ImageBackground
                style={{ flex: 1, paddingHorizontal: 20 }}
                source={Background.fullscreen}>

                <View style={{
                    alignItems: "center",
                    marginTop: 70,
                    marginBottom: 20
                }}>
                    <Image
                        source={Pet.greetingsFront}
                        style={{
                            objectFit: "contain",
                            width: 150,
                            height: 150,
                        }}
                    />
                </View>

                <Searchbar
                    style={{ marginBottom: 20, marginHorizontal: 20 }}
                    placeholder="Nombre"
                    value={searchText}
                    onChangeText={fetchTherapists}
                    onSubmitEditing={() => fetchTherapists(searchText, true)}
                    onClearIconPress={() => fetchTherapists()} />

                <ScrollView style={{
                    flex: 1,
                    marginBottom: 120,
                    paddingHorizontal: 20
                }}>
                    {
                        loading ?
                            <CardListLoader />
                            : therapistList && therapistList?.items.length > 0 ?
                                therapistList.items.map(therapist =>
                                    <TherapistCard
                                        key={therapist.therapist.id}
                                        therapist={therapist}
                                        onCardPress={openTherapistProfile} />
                                )
                                : submitted ?
                                    <Text style={{
                                        textAlign: 'center',
                                        fontSize: 20,
                                        color: theme.colors.onSurfaceVariant,
                                        marginTop: 20,
                                        marginBottom: 100
                                    }}>
                                        No se encontró ningún psicólogo con ese nombre.
                                    </Text>
                                    : <Text style={{
                                        textAlign: 'center',
                                        fontSize: 20,
                                        color: theme.colors.onSurfaceVariant,
                                        marginTop: 20,
                                        marginBottom: 100
                                    }}>
                                        Introduce el nombre del psicologo que le ha invitado a Kyra Health para continuar.
                                    </Text>
                    }
                </ScrollView>
            </ImageBackground>
        </SafeAreaView >
    );
}

export default SelectTherapist;
